export const en_33 = {   
    menu: {
        'send_balance': 'Send Load to Philippines',
        'auto_balance': 'Auto Load',
    },
    send_balance: {
        'auto_balance_title': 'Set Auto Load',
        'balance_pending': 'Load Pending',
        'balance_failed': 'Load Failed',
        'balance_success': 'Load Successful',
        'balance_phone_number_label': 'Load phone number',
        'select_amt_label': 'Select Load amt',
        'amount_missing': 'Please select the Load amount.',
        "topup_heading":"Send Globe Prepaid Load Online",
        "topup_sub_heading": "Enter the Globe number that you would like to reload",
        'reward_points_message': `You have {{reward}} reward points ({{discount}} {{currency}}). You can use up to {{discountTopup}} {{currency}} for this load.`,
        'zero_amount_payment_message': 'Congratulations! You have reward point to pay for this Load. You will not be charged for this transaction.',
    },
    auto_balance :{
        'topup_day': "Load day",
        'auto_balance_header': 'Active Auto Loads',
        'no_profile_msg': 'No Active auto load available. Please click below button to create new auto load.',
        'new_profile_button_title': 'New Auto load',
        'enable_profile_button_title': 'Enable Auto load',
        'balance_amount_label': 'Load Amount',
        'auto_balance_cancel_fail': "We are sorry. An error occurred while cancelling the auto load. Please contact customer support",
        'auto_balance_success': 'Auto Load successfully created.',
        'auto_balance_cancelled': 'Auto Load successfully cancelled.',
        'profile_created': 'Auto Load Created',
        'cancel_message': `Are you sure want to cancel the Auto Load to Mobile Number +{{internationalCode}} {{localMobileNumber}} ?`,
        'schedule': "Schedule: Every {{freq}} on {{topupDayString}} starting {{startDateFormated}}. Note: You can cancel auto load any time. No question asked.",
    },
    receipt:{
        'balance': 'Load Amount',
        'bonus_balance': 'Bonus Load',
        'total_balance': 'Total Load Amount',
        'topup-timeout': "Load Time out",
    },
    common:{
        "top-up": "Load",
    },
    myaccount:{
        "no_topup": "You do not have any Load",
        "delete-auto-topup-confirm-message": "Are you sure you want to cancel the Auto Load",
    },
    validations:{
        'reward_points_applied': `Congratulations! You are using {{rewardPointsUsed}} points towards this load. You will now be charged a net amount of {{netCharge}} {{currency}}.`,
        'reward_points_applied_full_amount': `Congratulations! You are using {{rewardPointsUsed}} points towards this load. You will not be charged for this transaction.`,
    }
}